import { render } from "./quick_add.vue?vue&type=template&id=027cd7c9"
import script from "./quick_add.vue?vue&type=script&lang=js"
export * from "./quick_add.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"

import exportComponent from "/home/raphael/git/proclima/retailerportal/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__